import { gql } from '@apollo/client';
import { NEW_GENERIC_ORDER } from '../fragments/generic-order';
import { NEW_ORDER } from '../fragments/orders';

// CREATE_NEW_GENERIC_ORDER, UPDATE_GENERIC_ORDER, UPDATE_GENERIC_ORDER_RELATIONSHIPS
// eliminados (Bloque C-Limpieza 2026-05-08): sustituidos por SAVE_GENERIC_ORDER
// atómica.

/**
 * Endpoint unificado que reemplaza CREATE_NEW_ORDER + CREATE_NEW_GENERIC_ORDER +
 * UPDATE_ORDER + UPDATE_GENERIC_ORDER + UPDATE_GENERIC_ORDER_RELATIONSHIPS +
 * UPDATE_ORDER_RELATIONSHIPS del flujo NewOrder/DuplicateOrder.
 * Ver PLAN-SAVE-ENTITY-UNIFIED.md §2.4.
 */
export const SAVE_GENERIC_ORDER = gql`
  mutation SaveGenericOrder($input: SaveGenericOrderInput!) {
    saveGenericOrder(input: $input) {
      order {
        ...NewOrder
      }
      genericOrder {
        ...NewGenericOrder
      }
    }
  }
  ${NEW_ORDER}
  ${NEW_GENERIC_ORDER}
`;
